import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { TRIAL_CONTINUE_MESSAGE, TRIAL_CONTINUE_TITLE, RESTRICTION_CTA } from "@/lib/trialCopy";

export function SubscriptionExpired() {
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState(TRIAL_CONTINUE_MESSAGE);

  useEffect(() => {
    const onExpired = (e) => {
      setDetail((e && e.detail) || TRIAL_CONTINUE_MESSAGE);
      setOpen(true);
    };
    window.addEventListener("gx-subscription-expired", onExpired);
    return () => window.removeEventListener("gx-subscription-expired", onExpired);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="subscription-expired-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{TRIAL_CONTINUE_TITLE}</DialogTitle>
          <DialogDescription>{detail || TRIAL_CONTINUE_MESSAGE}</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Your workspace is still here. Reads stay open; writing, jobs, and EMIE wait until you continue with a plan.
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            Keep looking around
          </Button>
          <Link to="/dashboard/billing" onClick={() => setOpen(false)}>
            <Button className="gap-2 font-semibold" data-testid="subscription-expired-cta">
              <CreditCard className="h-4 w-4" />
              {RESTRICTION_CTA.trial_expired}
            </Button>
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
